import { __decorate } from "tslib";
import { attr, customElement, FASTElement, html, when } from '@microsoft/fast-element';
import { SVG_ALERT_INACTIVE, SVG_CHECKBOX_CHECK } from '@getgo/chameleon-icons';
import { ensureDefaultAttribute } from '../../common/utils/Attributes';
import { ChameleonElementMixin } from '../../common/ChameleonElement';
import styles from './ProgressStep.styles.scss';
const template = html `<template slot="step">
  <span class="badge">
    ${when((x) => x.shouldShowDangerState(), html `<chameleon-svg>${SVG_ALERT_INACTIVE}</chameleon-svg>`)}
    ${when((x) => x.shouldShowSuccessState(), html `<chameleon-svg>${SVG_CHECKBOX_CHECK}</chameleon-svg>`)}
    ${when((x) => x.shouldShowBadgeValue(), html `<span>${(x) => x.badgeValue}</span>`)}
  </span>
  <div class="step-text">
    <chameleon-typography class="step-name" nowrap color="inherit">
      <slot></slot>
    </chameleon-typography>
    <div class="step-description">
      <slot name="description"></slot>
    </div>
  </div>
</template>`;
export const progressStepDefinition = {
    name: 'chameleon-progress-step',
    template,
    styles,
};
let ProgressStepComponent = class ProgressStepComponent extends ChameleonElementMixin(FASTElement) {
    constructor() {
        super(...arguments);
        this.disabled = false;
        this.badgeValue = '';
        this.selected = false;
    }
    selectedChanged(_oldValue, newValue) {
        if (newValue) {
            this.$emit('change', null, { bubbles: false });
        }
    }
    connectedCallback() {
        super.connectedCallback();
        ensureDefaultAttribute(this, 'variant', 'neutral');
    }
    shouldShowDangerState() {
        return this.variant === 'danger';
    }
    shouldShowSuccessState() {
        return !this.selected && this.variant === 'success';
    }
    shouldShowBadgeValue() {
        return (this.selected || this.variant !== 'success') && !this.shouldShowDangerState();
    }
};
__decorate([
    attr
], ProgressStepComponent.prototype, "variant", void 0);
__decorate([
    attr({ mode: 'boolean' })
], ProgressStepComponent.prototype, "disabled", void 0);
__decorate([
    attr({ attribute: 'badgevalue' })
], ProgressStepComponent.prototype, "badgeValue", void 0);
__decorate([
    attr({ mode: 'boolean' })
], ProgressStepComponent.prototype, "selected", void 0);
ProgressStepComponent = __decorate([
    customElement(progressStepDefinition)
], ProgressStepComponent);
export { ProgressStepComponent };
